export enum taskIdsEnums {
  erect = '952f484a-bf75-4c89-8c2c-4a89fee5a5e1',
  modify = '129d57f3-d1e5-45ed-8ec7-2c4fd0ec7534',
  other = '8196fa49-cab5-4d74-88e6-86ca515bc433',
  dismantle = '836387fc-558a-4851-b626-2546fb0624ab'
}
